import React from 'react';
import { Link } from 'react-router-dom';

const CallToAction: React.FC = () => {
  return (
    <section id="get-involved" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-4xl sm:text-4xl md:text-4xl font-bold text-gray-900 mb-6">How You Can Help</h2>
          <p className="text-lg text-gray-600 mb-8">
            Your support can create lasting change in communities. Join us in making a difference today.
          </p>

          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-4 mt-8">
            <Link
              to="/volunteer"
              className="px-6 md:px-8 py-3 bg-primary hover:bg-primary-dark hover:shadow-lg text-white font-medium rounded-full transition-all duration-300 transform hover:scale-105 text-center"
            >
              Volunteer With Us
            </Link>
            <Link
              to="/donation"
              className="px-6 md:px-8 py-3 bg-secondary hover:bg-secondary-dark hover:shadow-lg text-white font-medium rounded-full transition-all duration-300 transform hover:scale-105 text-center"
            >
              Donate Now
            </Link>
            <Link
              to="/contact"
              className="px-6 md:px-8 py-3 bg-gradient-to-r from-primary to-secondary hover:shadow-lg text-white font-medium rounded-full transition-all duration-300 transform hover:scale-105 text-center"
            >
              Contact Us
            </Link>
            <Link
              to="/support-request"
              className="px-6 py-3 bg-gradient-to-r from-[#0F766E] to-[#134E4A] hover:shadow-xl text-white font-medium rounded-full transition-all duration-300 transform hover:scale-105 text-center">
              Request support
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
